export enum NOTIFICATION_ACTION_TYPES {
  SETUP_NOTIFICATION_LISTENER_REQUEST = 'NOTIFICATION_SETUP_NOTIFICATION_LISTENER_REQUEST',
  SETUP_NOTIFICATION_LISTENER_SUCCESS = 'NOTIFICATION_SETUP_NOTIFICATION_LISTENER_SUCCESS',
  SETUP_NOTIFICATION_LISTENER_FAILURE = 'NOTIFICATION_SETUP_NOTIFICATION_LISTENER_FAILURE',

  CHECK_NOTIFICATION_AVAILABILITY_REQUEST = 'NOTIFICATION_CHECK_NOTIFICATION_AVAILABILITY_REQUEST',
  CHECK_NOTIFICATION_AVAILABILITY_SUCCESS = 'NOTIFICATION_CHECK_NOTIFICATION_AVAILABILITY_SUCCESS',
  CHECK_NOTIFICATION_AVAILABILITY_FAILURE = 'NOTIFICATION_CHECK_NOTIFICATION_AVAILABILITY_FAILURE',

  REGISTER_REMOTE_NOTIFICATION_REQUEST = 'NOTIFICATION_REGISTER_REMOTE_NOTIFICATION_REQUEST',
  REGISTER_REMOTE_NOTIFICATION_SUCCESS = 'NOTIFICATION_REGISTER_REMOTE_NOTIFICATION_SUCCESS',
  REGISTER_REMOTE_NOTIFICATION_FAILURE = 'NOTIFICATION_REGISTER_REMOTE_NOTIFICATION_FAILURE',

  SUBSCRIBE_TO_TOPICS_REQUEST = 'NOTIFICATION_SUBSCRIBE_TO_TOPICs_REQUEST',
  SUBSCRIBE_TO_TOPICS_SUCCESS = 'NOTIFICATION_SUBSCRIBE_TO_TOPICs_SUCCESS',
  SUBSCRIBE_TO_TOPICS_FAILURE = 'NOTIFICATION_SUBSCRIBE_TO_TOPICs_FAILURE',

  UNSUBSCRIBE_FROM_TOPICS_REQUEST = 'NOTIFICATION_UNSUBSCRIBE_FROM_TOPICS_REQUEST',
  UNSUBSCRIBE_FROM_TOPICS_SUCCESS = 'NOTIFICATION_UNSUBSCRIBE_FROM_TOPICS_SUCCESS',
  UNSUBSCRIBE_FROM_TOPICS_FAILURE = 'NOTIFICATION_UNSUBSCRIBE_FROM_TOPICS_FAILURE',

  UNSUBSCRIBE_FROM_ALL_REQUEST = 'NOTIFICATION_UNSUBSCRIBE_FROM_ALL_REQUEST',
  UNSUBSCRIBE_FROM_ALL_SUCCESS = 'NOTIFICATION_UNSUBSCRIBE_FROM_ALL_SUCCESS',
  UNSUBSCRIBE_FROM_ALL_FAILURE = 'NOTIFICATION_UNSUBSCRIBE_FROM_ALL_FAILURE'
}
